module.exports = __webpack_public_path__ + "prod/1.42.2/img/difficulty-two.b29dcc9c.png";